import React from 'react';
import FormInputText from './FormInputTexto';

export const EMAIL_PATTERN = /^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?$/;

type IInputProps = Omit<React.ComponentProps<typeof FormInputText>, 'type'>;

const FormInputEmail: React.FC<IInputProps> = ({ pattern, patternMessage, ...props }) => (
  <FormInputText
    {...props}
    type="email"
    pattern={pattern ?? EMAIL_PATTERN}
    patternMessage={patternMessage ?? 'Introduzca un correo electrónico válido'}
  />
);

export default FormInputEmail;